export const TIMEOUT = {
  // all values below are in milliseconds
  LOCATIONS_IMPORT_STATUS_UPDATE_INTERVAL: 10000,
  LOCATIONS_IMPORT_STATUS_UPDATE_INTERVAL_WIZARD: 10000
};
